import Icon from 'vue-awesome/components/Icon'

Icon.register({
  control_camera_rounded: {
    raw: '<path d="M4.65 9.35L2.7 11.3a.996.996 0 000 1.41l1.95 1.95c.49.49 1.28.49 1.77 0 .48-.49.48-1.27 0-1.76l-.88-.9.88-.89c.48-.49.48-1.27 0-1.76a1.25 1.25 0 00-1.77 0zm12.93 0c-.48.49-.48 1.27 0 1.76l.88.89-.88.89c-.48.49-.48 1.27 0 1.76.49.49 1.28.49 1.77 0l1.95-1.95a.996.996 0 000-1.41l-1.95-1.95c-.49-.48-1.29-.48-1.77.01zM12 18.46l-.89-.88c-.49-.48-1.27-.48-1.76 0a1.25 1.25 0 000 1.77l1.95 1.95c.39.39 1.02.39 1.41 0l1.95-1.95c.49-.49.49-1.28 0-1.77-.49-.48-1.27-.48-1.76 0l-.9.88zM9.35 6.42c.49.48 1.27.48 1.76 0l.89-.88.89.88c.49.48 1.27.48 1.76 0 .49-.49.49-1.28 0-1.77L12.7 2.7a.996.996 0 00-1.41 0L9.35 4.65a1.25 1.25 0 000 1.77z"/><circle cx="12" cy="12" r="3"/>',
    width: '24',
    height: '24'
  }
})
